// extracted by mini-css-extract-plugin
export default {"btn-state-wait":"PollingItem_btn-state-wait__1zDyG","btn-state-isdone":"PollingItem_btn-state-isdone__MCqIi","btn-state-err":"PollingItem_btn-state-err__MskUy"};